module.exports = __webpack_public_path__ + "static/media/cmdstalowa.88287e16.png";